// extracted by mini-css-extract-plugin
export default {"prLink":"RunDetails__prLink__uPCj0","prLinkTitle":"RunDetails__prLinkTitle__Omffw"};